<template>
    <div class=".container-fluid full-height" :style="[{ backgroundImage: 'url(' + require('../assets/bg.jpg') + ')' },{backgroundSize:'100%'},{backgroundPosition:'center bottom'}]">
        <NavBar></NavBar>


            

                <div class="d-flex justify-content-center">
                    <img src="@/assets/unk_hd_bg.png" style="height:20vh;width:auto;margin-top:5vh;border-radius:10vh">
                </div>

                <div class="d-flex justify-content-center" style="margin-top:5vh;">
                    <div class = "border p-3 pb-8" style="background:#0099FF;border-radius: 10px;">
                        <h2 style="padding-top:0px;padding-bottom:10px;font-size:16px">Search Seafarers</h2>
                        <form class="form-inline" novalidate>
                            <div class="form-group pl-3 p4-3">
                                <label for="exampleInputName2" style="padding-right:10px;font-size:14px">Name</label>
                                <b-form-input type="text" class="form-control  itextinput" placeholder="Tom Cruise" v-model="searchName" ></b-form-input>
                            </div>
                            <div class="form-group pl-3">
                                <label for="exampleInputName2" style="padding-right:10px;font-size:14px">CDC</label>
                                <b-form-input type="text" class="form-control  itextinput" placeholder="CXXXXXX" v-model="searchCDCNo" ></b-form-input>

                            </div>
                            <div class="form-group pl-3">
                                <label for="exampleInputEmail2" style="padding-right:10px;font-size:14px">DOB</label>
                                <b-form-input id="fromDate" type="text" class="form-control  itextinput" v-model="searchDOB" placeholder="DD/MM/YYYY" required  @blur="validateDateonBlur" :formatter="dateformatter" maxlength="10" :state="isValidDateForInput(searchDOB)"></b-form-input>

                            </div>
                            <button type="button" class="btn btn-primary ibutton" v-on:click="searchSeafarer()" style="margin-left:10px;font-size:14px">
                                <span class="spinner-border spinner-border-sm mr-3" role="status" aria-hidden="true" v-if="this.isLoading"> </span>
                                Search
                            </button>
                        </form>
                    </div>
                    
                </div>


                <div class="d-flex justify-content-center" style="padding-top:5vh;font-size:8px" v-if="isUserAdminOrOperator">
                    <div class = "border p-4 pt-3" style="background: #0099FF;border-radius: 10px;">
                        <h3 style="padding-top:0px;padding-bottom:10px;font-size:16px">Shortcuts</h3>
                        <button type="button" class="btn btn-primary ibutton" style="margin-right:5px;font-size:14px" v-on:click="newSeafarer()">New Seafarers</button>
                        <button type="button" class="btn btn-primary ibutton" style="font-size:14px;padding-left:24px;padding-right:24px" v-on:click="newVessel()">New Vessel</button>
                    </div>
                </div>             

                    
                        

                    
                <v-snackbar v-model="showSnackbar" >
                    {{ snackBarText }}
                    <template v-slot:action="{ attrs }"> <v-btn :color="snackbarColor" text v-bind="attrs" @click="showSnackbar = false">Close</v-btn></template>
                </v-snackbar>
                    

                    

        <Footer class="footerStickedToBottom" ></Footer>        
 
    </div>    
</template>

<script>

import NavBar  from '@/components/NavBar';
import Footer from '@/components/Footer';
import {DB} from '../firebase/db';
import Utils from '@/utils/util.js';


export default {   
    name: 'Home',  
    data() {
        return {
            bgImage: "/img/bg.jpg",
            searchName:'',
            searchCDCNo:'',
            searchDOB:'',
            showSnackbar:false,
            snackBarText:'',
            snackbarColor:'green',

            isLoading:false,
            data:[],
        }
    },
    components: {          
        NavBar,         
        Footer,        
    },
    created() {
    },
    computed:{
        isUserAdminOrOperator(){
          if(this.$store.state.user != undefined && this.$store.state.user != null){
              if(this.$store.state.user.role != undefined && (this.$store.state.user.role == 'Admin' || this.$store.state.user.role == 'Operator')){
                  return true;
              }
          }
          return false;
      },
    },
    methods: {  
        dateformatter(value){
            return Utils.dateformatter(value);
        },
        isValidDateForInput(dateIn){
            return Utils.isValidDateForInput(dateIn);
        },
        validateDateonBlur(e){
            if(e.target.id == 'fromDate'){
                if(Utils.isValidDate(this.searchDOB) == false){
                    this.showError('Date is invalid. Format should be DD/MM/YYYY');
                }
            }
            
        }, 
            async searchSeafarer(){

                this.isLoading = true;
                const _this = this;
                this.data = [];

                DB.collection("seafarers").
                    orderBy("modifiedAt", "desc").
                    get()
                    .then((querySnapshot) => {

                        for(var doc of querySnapshot.docs){

                            var seafarer = doc.data();

                            if(this.searchName != ''){

                                if(seafarer.otherName.toLowerCase().includes(this.searchName.toLowerCase()) || seafarer.surname.toLowerCase().includes(this.searchName.toLowerCase())){

                                    if(this.searchCDCNo != ''){
                                        
                                        if(seafarer.cdcNo.toLowerCase().includes(this.searchCDCNo.toLowerCase())){
                                            
                                            if(this.searchDOB != ''){
                                                
                                                if(seafarer.dob.toLowerCase().includes(this.searchDOB.toLowerCase())){
                                                    this.data.push(doc.data());
                                                }

                                            }else{
                                                this.data.push(doc.data());
                                            }
                                        }

                                    }else{
                                        if(this.searchDOB != ''){
                                        
                                            if(seafarer.dob.toLowerCase().includes(this.searchDOB.toLowerCase())){
                                                this.data.push(doc.data());
                                            }

                                        }else{
                                            this.data.push(doc.data());
                                        }
                                    }

                                }

                            }else if(this.searchCDCNo != ''){

                                if(seafarer.cdcNo.toLowerCase().includes(this.searchCDCNo.toLowerCase())){
                                    
                                    if(this.searchDOB != ''){
                                        
                                        if(seafarer.dob.toLowerCase().includes(this.searchDOB.toLowerCase())){
                                            this.data.push(doc.data());
                                        }
                                        
                                    }else{
                                        this.data.push(doc.data());
                                    }
                                }

                            }else if(this.searchDOB != ''){
                                if(seafarer.dob.toLowerCase().includes(this.searchDOB.toLowerCase())){
                                    this.data.push(doc.data());
                                }
                            }
                        }

                            
                        


                        if(this.data.length == 0){
                            this.showSnackbar = true;
                            this.snackBarText = "No results found!"
                        }else{
                            if(this.data.size == 1){                                
                                var route = '/edit-seafarer?id=' + this.data[0].id  + '&mode=edit'          
                                this.$router.push(route);
                            }else{
                                
                                this.$router.push({name: 'Seafarers', params: { propData: this.data, propTitle: "Search Results"}});
                            }
                        }

                        _this.isLoading = false;
                    })
                    .catch((error) => {
                        _this.showError("Failed to fetch records. Error: ", error)
                        _this.data = [];
                        _this.isLoading = false;
                    });
                
             },
             newSeafarer(){
                 this.$router.push("/seafarer");
             },
             newVessel(){
                 this.$router.push("/vessel");
             },
             showError(err){
                this.snackBarText = err;
                this.snackbarColor = 'red';
                this.showSnackbar = true;
            },          
            showMsg(msg){
                this.snackBarText = msg;
                this.snackbarColor = 'green';
                this.showSnackbar = true;
            },    
    },
    
}


</script>



<style lang="scss">

</style>